import React from 'react';
import { APPOINTMENT_ROOMS, getRoomColorStyles } from './calendarUtils';

const CalendarRoomLegend: React.FC = () => (
  <div className="flex flex-wrap items-center gap-1.5">
    {APPOINTMENT_ROOMS.map((room) => {
      const colors = getRoomColorStyles(room);
      return (
        <span
          key={room}
          className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 py-[3px] pl-[7px] pr-2.5 text-[11px] font-medium text-slate-600"
        >
          <span className={`h-[7px] w-[7px] shrink-0 rounded-full ${colors.dot}`} />
          {room}
        </span>
      );
    })}
  </div>
);

export default CalendarRoomLegend;
